import {
  SearchReliefListingsEducatorResultDocument,
  SearchReliefListingsLearnerResultDocument,
  SearchReliefListingsShowEducatorCapabilities,
  SearchReliefListingsShowLearnerCapabilities,
} from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type ShowLearnerProps = {
  relief_listing: SearchReliefListingsLearnerResultDocument
  listing_uuid: string
  capabilities: SearchReliefListingsShowLearnerCapabilities
}

export const useShowLearnerProps = () => useProps<ShowLearnerProps>()

export type ShowEducatorProps = {
  relief_listing: SearchReliefListingsEducatorResultDocument
  listing_uuid: string
  capabilities: SearchReliefListingsShowEducatorCapabilities
}
export const useShowEducatorProps = () => useProps<ShowEducatorProps>()
